import { useSyncExternalStore } from 'react';

/**
 * Module-level pub/sub so `GettingStartedPage` can tell `DefaultLayout` to
 * hide the sidebar and top bar while the user is mid-onboarding. Kept outside
 * React context because the layout lives above the page in the tree — a
 * context provider rendered by the page can't drive siblings above it.
 *
 * The page flips the flag based on its own `isOnboardingComplete` state and
 * always clears it on unmount, so navigating away from `/getting-started`
 * restores the chrome even if the page forgot to reset it.
 */

let hidden = false;
const listeners = new Set<() => void>();

export function setOnboardingChromeHidden(next: boolean): void {
  if (hidden === next) return;
  hidden = next;
  listeners.forEach((l) => l());
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function getSnapshot(): boolean {
  return hidden;
}

export function useOnboardingChromeHidden(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
